
export const API = process.env.REACT_APP_API_URL;

// Este archivo esta deshabilitado el seguimiento de cambios futuros para el archivo: git update-index --assume-unchanged src/api/URL_API.js
// Para revertir esta configuracion aplicar: git update-index --no-assume-unchanged src/api/URL_API.js
